import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';

//import components
import ItemText from './ItemText.js';

const ItemSubSection = ({ clang, list, seeMore }) => {
    return (
        <div className="item__subsection--separate">
            {list.map((listItem, index) =>
                <div key={index} className="item__subsection">
                    <label className="item__subsection-label">
                        <span className="item__subsection-label__inner">{listItem.label}:</span>
                    </label>
                    <div className="item__subsection-content">
                        {listItem.values.map((arrItem, arrItemIndex) =>
                          arrItemIndex !== listItem.values.length - 1 ?
                          <div className="item__subsection-content--inner" key={arrItemIndex}>
                            <ItemText
                              text={`${arrItem.label}`}
                              link={arrItem.link}
                              type={arrItem.entityType}/>
                            <span>,</span>
                          </div>
                          :
                          <div className="item__subsection-content--inner" key={arrItemIndex}>
                            <ItemText
                              text={arrItem.label}
                              link={arrItem.link}
                              type={arrItem.entityType}/>
                          </div>)}
                    </div>
                </div>)}
        </div>
    );
};

ItemSubSection.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemSubSection);



// WEBPACK FOOTER //
// ./src/components/items/ItemSubSection2.js